import { version } from './pkginfo.json';
export var VERSION = version;
//# sourceMappingURL=version.js.map